import { useEffect, useState, useMemo } from "react"
import { M_Select } from "../../../../M_Components";
import "../item.css";
import { useTranslation } from "react-i18next";

export const DropdownFieldItemForm = ({ field, changeValueCallback, itemForm, isDisabled }) => {
    const { i18n } = useTranslation();
    const currentLanguage = i18n.resolvedLanguage;
    const defaultValue = useMemo(() => field.AllowMultiple ? [] : null, [field.AllowMultiple]);
    const [selectedItems, setSelectedItems] = useState(defaultValue);

    const label = useMemo(() =>
        field.Captions[currentLanguage]?.length > 0 ? field.Captions[currentLanguage] : field.Code,
        [field, currentLanguage]);

    const options = useMemo(() =>
        field.DropdownItems.filter(i => !i.isDeleted && !i.IsDeleted).map(i => {
            const captions = i.Captions || i.captions || {};
            const itemId = i.DropdownItemId || i.dropdownItemId;
            return {
                label: captions[currentLanguage] || captions["en"] || itemId || "Unknown",
                value: itemId,
                Id: itemId
            };
        }), [field.DropdownItems, currentLanguage]);

    const handleChange = (value) => {
        const normalized = Array.isArray(value) ? value : value ? [value] : [];
        const parsedValues = normalized.map(v => v.Id);
        changeValueCallback({
            ...itemForm,
            form: { ...itemForm.form, [field.Code]: parsedValues.length ? JSON.stringify(parsedValues) : null }
        });
    };

    useEffect(() => {
        const rawValue = itemForm.form[field.Code];
        if (!rawValue || options.length === 0) { setSelectedItems(defaultValue); return; }

        let parsedIds = [];
        try {
            const parsed = JSON.parse(rawValue);
            parsedIds = Array.isArray(parsed) ? parsed : [parsed];
        } catch {
            const num = Number(rawValue);
            if (!isNaN(num)) parsedIds = [num];
        }

        const matched = parsedIds
            .map(id => options.find(o => Number(o.Id) === Number(id)))
            .filter(Boolean);

        if (matched.length === 0) { setSelectedItems(defaultValue); return; }

        if (field.AllowMultiple) {
            setSelectedItems(isDisabled ? matched.map(o => o.value) : matched);
        } else {
            setSelectedItems(isDisabled ? matched[0]?.value : matched[0]);
        }
    }, [itemForm.form, options, isDisabled, field.Code, field.AllowMultiple]);

    return (
        <div className="dropdown">
            <M_Select
                autocomplete={!isDisabled}
                label={label}
                value={selectedItems}
                noNone={!field.IsMandatory}
                multiple={field.AllowMultiple}
                options={options}
                disabled={isDisabled}
                onChangeValue={handleChange}
            />
        </div>
    );
}
